export default __webpack_public_path__ + "static/radiancelogo-ab2d897d1a7553f5919a53d1d5bc6f6f.svg";